"use client";

import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import {
  inferAdditionalFields,
  phoneNumberClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { auth } from "@/lib/auth";

/**
 * 화면(클라이언트 컴포넌트)용 인증 클라이언트. 같은 출처의 /api/auth 를 부른다.
 *
 * oauthProviderClient 는 로그인·가입·동의 요청에 현재 주소의 서명된 OAuth 질의(oauth_query)를
 * 자동으로 붙인다. 그래서 OAuth 인가 도중 로그인하면 서버가 인가를 이어서 진행하고
 * `{ redirect: true, url }` 로 다음 주소를 돌려준다(기본 redirect 플러그인이 이동시킨다).
 */
export const authClient = createAuthClient({
  plugins: [
    inferAdditionalFields<typeof auth>(),
    phoneNumberClient(),
    oauthProviderClient(),
  ],
});
